import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function fetchMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function createSession(session_id) {
  const { data } = await api.post("/auth/session", { session_id });
  return data;
}

export async function logout() {
  await api.post("/auth/logout");
}

export async function submitQuestionnaire(kind, answers, phase = "baseline") {
  const { data } = await api.post("/questionnaires/submit", { kind, answers, phase });
  return data;
}

export async function saveSmartGoals(goals) {
  await api.post("/smart-goals", { goals });
}

export async function saveAbcExercises(responses) {
  await api.post("/abc-exercises", { responses });
}

export async function saveQuiz(quizId, answers, score) {
  await api.post(`/quizzes/${quizId}`, { answers, score });
}

export async function getSummarySession1() {
  const { data } = await api.get("/summary/session1");
  return data;
}

export async function saveProgress(session_number, step, completed, payload) {
  await api.post("/progress", { session_number, step, completed, payload });
}

export async function getSessionProgress(session_number) {
  const { data } = await api.get(`/progress/${session_number}`);
  return data;
}
